<div>
    <ion-row class="new-design">
        <ion-col size="12" class="row-main-title">
            <div class="title-section">
                <div class="title-container">
                    <ion-label class="title"> {{ (toolService.content | async)?.application?.components?.generalDocuments?.contract?.titleNew }}</ion-label>
                </div>
            </div>
        </ion-col>
        <!-- do not show the clinical agreement selection when override for B2B apps is in place -->
        <ng-container *ngIf="status?.application?.applicationordertype !== 'B2B' || !!status?.application?.contracturl || !!status?.application?.signedcontract === false">
            <ion-col class="requirement-col" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4">
                <div class="requirement-content">
                    <ion-text class="ion-text-wrap bold-text">
                        <fa-icon [icon]="icons.faFileSignature"></fa-icon>
                        {{ (toolService.content | async)?.application?.components?.generalDocuments?.contract?.button }}
                    </ion-text>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div *ngIf="!complete?.signedcontract" class="requirement-content">
                    <div class="ion-text-center">
                        <ion-button (click)="clinicalAgreement()" fill="clear" color="dark-teal" class="upload-btn">
                            <!-- <ng-container [ngTemplateOutlet]="selectIconOnCondition"></ng-container> -->
                            <fa-icon [icon]="icons.faSignature"></fa-icon>
                            Sign document
                        </ion-button>
                    </div>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div class="requirement-content">
                    <div class="ion-text-center" *ngIf="complete?.signedcontract">
                        <ion-button (click)="clinicalAgreement()" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>
                    </div>
                </div>
            </ion-col>
        </ng-container>
        <ion-col *ngIf="complete?.signedcontract && showPreEnrollmentRegistration === true" size="12">
            <div class="title-section">
                <div class="title-container">
                    <ion-label *ngIf="!existingPreEnrollmentOrientation" class="title">Register for your Online Orientation. </ion-label>
                    <ion-label *ngIf="existingPreEnrollmentOrientation" class="title">Attend your Online Orientation. </ion-label>
                </div>
            </div>
        </ion-col>
        <ion-col size="1" size-xs="0" size-sm="0" size-md="0" size-lg="1" size-xl="1"> </ion-col>
        <ion-col
            *ngIf="complete?.signedcontract && showPreEnrollmentRegistration === true"
            size="5"
            size-xs="12"
            size-sm="12"
            size-md="12"
            size-lg="5"
            size-xl="5"
        >
            <div style="width: 100%; padding-top: 0.5em" class="ion-text-center">
                <ion-label class="section-title" color="dark-teal">Select Date & Time</ion-label>
            </div>
            <ion-list style="padding-top: 1em">
                <div *ngIf="!existingPreEnrollmentOrientation" class="ion-text-center">
                    <ion-select
                        ok-text="Register"
                        [interfaceOptions]="orientationAlertOptions"
                        placeholder="Select Date"
                        class="orientation-select basic-select"
                        formControlName="preEnrollmentSelection"
                        (ionChange)="preEnrollmentConferenceSelected($event)"
                    >
                        <p>{{ orientations }}</p>
                        <ion-select-option *ngFor="let conference of orientations?.preenrollmentschedule" [value]="conference">
                            {{ conference.datetime | date : 'mediumDate' }}
                            {{ conference.datetime | date : 'shortTime' }}
                        </ion-select-option>
                    </ion-select>
                </div>
                <div *ngIf="existingPreEnrollmentOrientation" class="ion-text-center">
                    <ion-text>
                        <p>
                            Your Orientation starts
                            {{ existingPreEnrollmentOrientation?.datetime | date : 'long' }}
                        </p>
                        <p>
                            You will receive an email from AMOpportunities as a reminder for your Pre-Enrollment Orientation. Attendance is mandatory. If you
                            have questions, please email
                            <a href="mailto:success@amopportunities.org">success&#64;amopportunities.org</a>
                        </p>
                        <ion-button href="{{ existingPreEnrollmentOrientation?.url }}" target="_blank">
                            <ion-text class="ion-text-wrap bold"> View my Orientation. </ion-text>
                        </ion-button>
                        <ion-button type="button" fill="clear" class="btn-link-text" (click)="preEnrollmentChange()">
                            <ion-text class="ion-text-wrap bold"> Change my date. </ion-text>
                        </ion-button>
                    </ion-text>
                </div>
            </ion-list>
        </ion-col>
        <ion-col
            *ngIf="complete?.signedcontract && showPreEnrollmentRegistration === true"
            size="5"
            size-xs="12"
            size-sm="12"
            size-md="12"
            size-lg="5"
            size-xl="5"
        >
            <div class="next-card-container">
                <ion-card class="next-card">
                    <div>
                        <div class="card-header">
                            <ion-label class="section-title" color="secondary">
                                <fa-icon [icon]="icons.question" slot="start"></fa-icon>
                                FAQ
                            </ion-label>
                        </div>
                    </div>
                    <ion-text color="text">
                        <p class="card-text">
                            In order to complete your enrollment, you will need to submit several documents, including identity paperwork, immunizations, health
                            insurance, and more! This interactive webinar will give you and in depth explanation of each requirement, allow you to have all of
                            your questions answered, and prepare you to enroll for your upcoming clinical experience.
                        </p>
                    </ion-text>
                </ion-card>
            </div>
        </ion-col>

        <ion-col *ngIf="complete?.signedcontract && showPreDepartureRegistration === true" size="12">
            <div class="title-section">
                <div class="title-container">
                    <ion-label *ngIf="!existingPreDepartureOrientation" class="title">Register for your Online Orientation. </ion-label>
                    <ion-label *ngIf="existingPreDepartureOrientation" class="title">Attend your Online Orientation. </ion-label>
                </div>
            </div>
        </ion-col>
        <ion-col size="1" size-xs="0" size-sm="0" size-md="0" size-lg="1" size-xl="1"> </ion-col>
        <ion-col
            *ngIf="complete?.signedcontract && showPreDepartureRegistration === true"
            size="5"
            size-xs="12"
            size-sm="12"
            size-md="12"
            size-lg="5"
            size-xl="5"
        >
            <div *ngIf="existingPreDepartureOrientation === null" style="width: 100%; padding-top: 0.5em" class="ion-text-center">
                <ion-label class="section-title" color="dark-teal">Select Date & Time</ion-label>
            </div>
            <ion-list style="padding-top: 1em">
                <div *ngIf="!existingPreDepartureOrientation" class="ion-text-center">
                    <ion-select
                        ok-text="Register"
                        [interfaceOptions]="orientationAlertOptions"
                        placeholder="Select Date"
                        class="orientation-select basic-select"
                        formControlName="preDepartureSelection"
                        (ionChange)="preDepartureConferenceSelected($event)"
                    >
                        <ion-select-option *ngFor="let conference of orientations?.predepartureschedule" [value]="conference">
                            {{ conference.datetime | date : 'mediumDate' }}
                            {{ conference.datetime | date : 'shortTime' }}
                        </ion-select-option>
                    </ion-select>
                </div>
                <div *ngIf="complete?.signedcontract && existingPreDepartureOrientation" class="ion-text-center">
                    <ion-text>
                        <p>
                            Your Orientation starts
                            {{ existingPreDepartureOrientation?.datetime | date : 'long' }}
                        </p>
                        <ion-button href="{{ existingPreDepartureOrientation?.url }}" target="_blank">
                            <ion-text class="ion-text-wrap bold"> View my Orientation. </ion-text>
                        </ion-button>
                        <ion-button type="button" fill="clear" class="btn-link-text" (click)="preDepartureChange()">
                            <ion-text class="ion-text-wrap bold"> Change my date. </ion-text>
                        </ion-button>
                    </ion-text>
                </div>
            </ion-list>
        </ion-col>
        <ion-col
            *ngIf="complete?.signedcontract && showPreDepartureRegistration === true"
            size="5"
            size-xs="12"
            size-sm="12"
            size-md="12"
            size-lg="5"
            size-xl="5"
        >
            <div class="next-card-container">
                <ion-card class="next-card">
                    <div>
                        <div class="card-header">
                            <ion-label class="section-title" color="secondary">
                                <fa-icon [icon]="icons.question" slot="start"></fa-icon>
                                FAQ
                            </ion-label>
                        </div>
                    </div>
                    <ion-text color="text">
                        <p class="card-text">
                            Welcome to the United States! Get ready for your upcoming travels as your AMO coaches cover topics such as getting an international
                            sim card, figuring out transportation to your rotation, and requesting an LOR from your physician. This valuable webinar will give
                            you all of the tools you need to succeed in your clinical experience.
                        </p>
                    </ion-text>
                </ion-card>
            </div>
        </ion-col>

        <ion-col size="1" size-xs="0" size-sm="0" size-md="0" size-lg="1" size-xl="1"> </ion-col>
    </ion-row>

    <div *ngIf="status?.application.signedcontract">
        <!-- ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS  ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS -->
        <!-- ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS  ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS -->
        <!-- ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS  ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS -->
        <!-- ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS  ELIGIBILITY DOCUMENTS ELIGIBILITY DOCUMENTS -->

        <ion-row
            class="new-design"
            *ngIf="
                status?.application?.program?.requiredpostdocumentlist?.requireEducation ||
                status?.application?.program?.requiredpostdocumentlist?.requireResume ||
                status?.application?.program?.requiredpostdocumentlist?.requireEnglish
            "
        >
            <ion-col size="12" class="row-main-title">
                <div class="title-section">
                    <div class="title-container">
                        <ion-label class="title">
                            {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.title }}
                        </ion-label>
                    </div>
                </div>
            </ion-col>
            <!-- DEAN'S LETTER   -->
            <ion-col class="requirement-col" size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4">
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.lorbutton }}
                            </span>
                        </ion-label>
                        <p>
                            You can either upload your school diploma or a letter of recommendation from your dean to fulfill this requirement.
                            <a [routerLink]="[]" (click)="downloadSample()">View Sample</a>
                        </p>
                    </div>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div class="requirement-content">
                    <div class="ion-text-center" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireEducation">
                        <ion-button
                            [disabled]="checklistStatus | checklist : 'schoolrecords'"
                            (click)="upload('schoolrecords', 'none')"
                            fill="clear"
                            color="primary"
                            class="upload-btn"
                        >
                            <fa-icon [icon]="icons.incompleted"></fa-icon>
                            {{ status?.user?.item4name ? 'Upload New Document' : 'Upload Document' }}
                        </ion-button>
                    </div>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div class="requirement-content" *ngIf="status?.user?.item4name">
                    <div class="ion-padding-top">
                        <div class="ion-text-center">
                            <ion-button (click)="viewBasicDocument('schoolrecords')" class="upload-btn upload-btn-color" fill="clear">
                                View document
                            </ion-button>
                        </div>
                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'schoolrecords'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- RESUME -->
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireResume"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.resumebutton }}
                            </span>
                        </ion-label>
                        <p *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireResume">
                            <a class="learn-more" (click)="openTooltip($event, 'cv', 'question')">
                                <fa-icon [icon]="icons.question" slot="start"></fa-icon>
                                <span>Learn more</span>
                            </a>
                            <!-- {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.rightCardTopContent }}
                        <a href="https://app.amopportunities.org/d/AMO_Sample_CV.pdf" target="_blank">here</a>. -->
                        </p>
                    </div>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div class="requirement-content">
                    <div class="ion-text-center" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireResume">
                        <ion-button
                            [disabled]="checklistStatus | checklist : 'cv'"
                            (click)="upload('cv', 'none')"
                            fill="clear"
                            color="primary"
                            class="upload-btn"
                        >
                            <fa-icon [icon]="icons.incompleted"></fa-icon>
                            {{ complete.cv ? 'Upload New Document' : 'Upload Document' }}
                        </ion-button>
                    </div>
                </div>
            </ion-col>
            <ion-col class="requirement-col" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4">
                <div class="requirement-content" *ngIf="complete.cv">
                    <div class="ion-padding-top">
                        <div class="ion-text-center">
                            <ion-button (click)="viewBasicDocument('cv')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>
                        </div>
                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'cv'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- ENGLISH -->

            <ion-col
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireEnglish && !hasUsCanPassport"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.proficiency }}
                            </span>
                        </ion-label>

                        <ion-text color="text">
                            <p class="card-text" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireEnglish && !hasUsCanPassport">
                                <a class="learn-more" (click)="openTooltip($event, 'Proficiency', 'infocircle')">
                                    <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                    <span>Learn more</span>
                                </a>
                                <!-- {{ (toolService.content | async)?.application?.components?.generalDocuments?.eligibility?.rightCardBottomContent }} -->
                            </p>
                        </ion-text>
                    </div>
                </div>
            </ion-col>
            <ion-col
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireEnglish && !hasUsCanPassport"
            >
                <div class="requirement-content ion-text-center">
                    <ion-button
                        [disabled]="checklistStatus | checklist : 'toefl'"
                        (click)="upload('toefl', 'none')"
                        fill="clear"
                        color="primary"
                        class="upload-btn"
                    >
                        <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                        {{ status?.user?.item10name ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </ion-col>
            <ion-col
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireEnglish && !hasUsCanPassport"
            >
                <div class="requirement-content ion-text-center" *ngIf="status?.user?.item10name">
                    <div class="ion-padding-top">
                        <ion-button (click)="viewBasicDocument('toefl')" class="upload-btn upload-btn-color" fill="clear"> View document </ion-button>

                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'toefl'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
        </ion-row>

        <!-- TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS  -->
        <!-- TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS  -->
        <!-- TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS  -->
        <!-- TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS TRAVEL DOCUMENTS  -->

        <ion-row
            class="new-design"
            *ngIf="
                status?.application?.program?.requiredpostdocumentlist?.requirePassport || status?.application?.program?.requiredpostdocumentlist?.requireVisa
            "
        >
            <ion-col size="12" class="row-main-title">
                <div class="title-section">
                    <div class="title-container">
                        <ion-label class="title"> {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.title }}</ion-label>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requirePassport"
                class="requirement-col"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.passportbutton }}
                            </span>
                        </ion-label>
                        <ion-text
                            color="text"
                            *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireVisa"
                            [innerHTML]="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContent | safe : 'html'"
                        >
                        </ion-text>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requirePassport"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content ion-text-center" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requirePassport">
                    <ion-button
                        [disabled]="checklistStatus | checklist : 'passport'"
                        (click)="upload('passport', 'none')"
                        fill="clear"
                        color="primary"
                        class="upload-btn"
                    >
                        <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                        {{ status?.user?.item2name ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requirePassport"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content" *ngIf="status?.user?.item2name">
                    <div class="ion-padding-top">
                        <ion-button (click)="viewBasicDocument('passport')" class="upload-btn upload-btn-color" expand="block" fill="clear" shape="round">
                            View document
                        </ion-button>

                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'passport'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- VISA -->
            <ion-col
                *ngIf="!complete.isOnlineTelehealth && !hasUsCanPassport"
                class="requirement-col"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <div>
                        <ion-text *ngIf="complete?.signedcontract" class="ion-text-wrap bold-text">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.visaestabutton }}
                        </ion-text>

                        <ion-text
                            color="text"
                            [innerHTML]="
                                (toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContentTelehealth | safe : 'html'
                            "
                        >
                        </ion-text>
                        <span
                            class="card-text"
                            *ngIf="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.rightCardContentTelehealth"
                        >
                            <a class="learn-more" (click)="openTooltip($event, 'rightCardContentTelehealth', 'infocircle')">
                                <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                <span>Learn more</span>
                            </a>
                        </span>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="!complete.isOnlineTelehealth && !hasUsCanPassport"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <div>
                        <div class="ion-text-center" *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireVisa">
                            <ion-button
                                [disabled]="checklistStatus | checklist : 'visaproof'"
                                (click)="upload('visaproof', 'none')"
                                fill="clear"
                                color="primary"
                                class="upload-btn"
                                [class.blocked-button]="status?.application?.states === 'Accepted'"
                            >
                                <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                {{ status?.user?.item7name ? 'Upload New Document' : 'Upload Document' }}
                            </ion-button>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="!complete.isOnlineTelehealth && !hasUsCanPassport"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content" *ngIf="status?.user?.item7name">
                    <div class="ion-padding-top">
                        <ion-button (click)="viewBasicDocument('visa')" class="upload-btn upload-btn-color" expand="block" fill="clear" shape="round">
                            View document
                        </ion-button>
                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'visaproof'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- INVITATION -->
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireVisa && status?.application?.requiresinvitation"
                class="requirement-col"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <div>
                        <fa-icon [icon]="icons.file"></fa-icon>

                        <ion-text class="ion-text-wrap bold-text">{{
                            (toolService.content | async)?.application?.components?.generalDocuments?.identity?.requestbutton
                        }}</ion-text>

                        <ion-text
                            color="text"
                            [innerHTML]="(toolService.content | async)?.application?.components?.generalDocuments?.identity?.invitationInfo | safe : 'html'"
                        >
                        </ion-text>
                        <a class="learn-more" (click)="openTooltip($event, 'Invite', 'infocircle')">
                            <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                            <span>Learn more</span>
                        </a>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireVisa && status?.application?.requiresinvitation"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <div class="ion-text-center">
                        <div>
                            <ion-button
                                (click)="openPassportModal()"
                                class="upload-btn"
                                fill="clear"
                                color="primary"
                                [disabled]="status?.application?.states !== 'Reserved' || complete?.hasrequestedinvitation"
                            >
                                <fa-icon [icon]="icons.file" slot="start"></fa-icon>
                                <ion-text class="ion-text-wrap">
                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.requestbutton }}
                                </ion-text>
                            </ion-button>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireVisa && status?.application?.requiresinvitation"
                class="requirement-col"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
            >
                <div class="requirement-content">
                    <!-- ***** Fix this visa invitation letter download link. Should only show if they have requested a letter and one was generated by admin.  ****** -->
                    <div class="ion-text-center health-link-container" *ngIf="complete?.invitationLetterReady">
                        <ion-button type="button" fill="clear" class="btn-link-text" color="secondary" (click)="downloadInvitationLetter()">
                            <ion-text class="ion-text-wrap bold">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.identity?.invitationdl }}
                            </ion-text>
                        </ion-button>
                    </div>
                </div>
            </ion-col>
        </ion-row>

        <!-- HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS -->
        <!-- HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS -->
        <!-- HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS -->
        <!-- HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS HEALTH DOCUMENTS -->

        <ion-row
            class="new-design"
            *ngIf="
                status?.application?.type === 'Hands-On' ||
                ((status?.application?.program?.requiredpostdocumentlist?.requireImmunization ||
                    status?.application?.program?.requiredpostdocumentlist?.requireHealthInsurance) &&
                    !complete.isOnlineTelehealth)
            "
        >
            <ion-col size="12" class="row-main-title">
                <div class="title-section">
                    <div class="title-container">
                        <ion-label class="title"> {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.titleNew }}</ion-label>
                    </div>
                </div>
            </ion-col>
            <!-- IMMUNIZATION RECORDS -->
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireImmunization && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.immunization }}
                            </span>
                        </ion-label>
                        <div
                            class="info-divs"
                            *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireImmunization && !complete?.isOnlineTelehealth"
                        >
                            <ion-text color="text">
                                <p class="card-text">
                                    Download the <a href="javascript: void(0);" (click)="downloadImmuneForm()">AMO Immunization Form</a> to be filled out.
                                    Upload the completed form once it is filled out, signed, and stamped by a physician. Upload the lab reports once received.
                                </p>
                            </ion-text>
                            <a href="javascript: void(0);" (click)="downloadImmuneForm()" class="anchor-btn-info">
                                <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                <span>AMO Immunization Form</span>
                            </a>
                            <span class="card-text learn-more">
                                <a class="learn-more" (click)="openTooltip($event, 'ImmunizationRecords', 'infocircle')">
                                    <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                    <span>Learn more</span>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireImmunization && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <ion-button (click)="upload('immune', 'none')" fill="clear" color="primary" class="upload-btn">
                        <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                        {{ complete.immune ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireImmunization && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <div class="ion-text-center pb-3" *ngIf="status?.immunizations?.documents.length !== 0">
                            <ion-button
                                *ngIf="status?.immunizations?.documents.length > 0"
                                fill="clear"
                                class="upload-btn upload-btn-color"
                                style="text-decoration: underline"
                                (click)="viewMultipleDocs(status?.immunizations?.documents, 'immune')"
                            >
                                View documents ({{ status?.immunizations?.documents.length }})
                            </ion-button>
                            <div *ngIf="status?.immunizations?.documents.length > 0" class="ion-text-center chip-container">
                                <app-document-status-chip [checklist]="immunizationGeneralStatus" [type]="'immunization'"></app-document-status-chip>
                            </div>
                        </div>
                        <div>
                            <ion-button (click)="openImmunizationModal($event)" expand="block" fill="clear" class="immunization-status-btn">
                                View Requirements Status
                            </ion-button>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- HEALTH INSURANCE -->
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireHealthInsurance && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.insurance }}
                            </span>
                        </ion-label>
                        <div class="info-divs">
                            <ion-text
                                color="text"
                                [innerHTML]="
                                    (toolService.content | async)?.application?.components?.generalDocuments?.health?.rightCardContentTelehealth | safe : 'html'
                                "
                            >
                            </ion-text>
                            <a
                                href="https://www.visitorscoverage.com/?utm_source=adwords&utm_medium=ppc&utm_term=visitors%20insurance&utm_campaign=VisitorsCoverage&hsa_grp=239717175&hsa_acc=3084178268&hsa_src=g&hsa_tgt=kwd-14371321&hsa_ver=3&hsa_kw=visitors%20insurance&hsa_mt=b&hsa_net=adwords&hsa_cam=7347495&hsa_ad=459453338291&gclid=Cj0KCQiA14WdBhD8ARIsANao07hHBebCjR0O6gwpOO6qQOvUtw-KiUfyxTil-ElM2I1R4odizmhh_sQaAlK3EALw_wcB"
                                class="anchor-btn-info"
                            >
                                <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                <span>Purchase Health Insurance</span>
                            </a>
                            <span class="card-text learn-more">
                                <a class="learn-more" (click)="openTooltip($event, 'HealthInsurance', 'infocircle')">
                                    <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                    <span>Learn more</span>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireHealthInsurance && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <ion-button
                        [disabled]="checklistStatus | checklist : 'healthinsurance'"
                        (click)="upload('healthinsurance', 'none')"
                        fill="clear"
                        class="upload-btn"
                        color="primary"
                    >
                        <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                        {{ complete.healthinsurance ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.program?.requiredpostdocumentlist?.requireHealthInsurance && !complete?.isOnlineTelehealth"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div class="ion-padding-top" *ngIf="complete.healthinsurance">
                        <ion-button
                            (click)="viewMultipleDocs(complete?.applicationHealthinsuranceDocuments, 'healthinsurance')"
                            class="upload-btn upload-btn-color"
                            expand="block"
                            fill="clear"
                            shape="round"
                        >
                            View document
                        </ion-button>

                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'healthinsurance'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE -->
            <!-- MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE -->
            <!-- MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE -->
            <!-- MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE  MALPRACTICE INSURANCE -->

            <ion-col
                *ngIf="status?.application?.type === 'Hands-On' && !customReqMalpracticeCheck"
                size="4"
                size-xs="12"
                size-sm="12"
                size-md="12"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.health?.malpracticebutton }}
                            </span>
                        </ion-label>
                        <div class="info-divs">
                            <ion-text
                                color="text"
                                *ngIf="status?.application?.type === 'Hands-On' || complete?.isOnlineTelehealth === true"
                                [innerHTML]="
                                    (toolService.content | async)?.application?.components?.generalDocuments?.health?.rightCardContentMalpractice
                                        | safe : 'html'
                                "
                            >
                            </ion-text>

                            <div class="info-divs" *ngIf="status?.application?.type === 'Hands-On' || complete?.isOnlineTelehealth === true">
                                <ion-text
                                    color="text"
                                    [innerHTML]="
                                        (toolService.content | async)?.application?.components?.generalDocuments?.health?.rightCardContentMalpractice
                                            | safe : 'html'
                                    "
                                >
                                </ion-text>
                                <a
                                    *ngIf="!complete?.purchasedMalpractice"
                                    (click)="purchaseMalpractice()"
                                    [disabled]="status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled'"
                                    class="anchor-btn-info"
                                >
                                    <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                    <span>Purchase Malpractice Insurance</span>
                                </a>
                                <span class="card-text learn-more">
                                    <a class="learn-more" (click)="openTooltip($event, 'MalpractiseInsurance', 'infocircle')">
                                        <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                        <span>Learn more</span>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.type === 'Hands-On' && !customReqMalpracticeCheck"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <ion-button
                        (click)="upload('malpractice', 'none')"
                        [disabled]=""
                        [disabled]="
                            checklistStatus
                                | checklist : 'malpractice' || (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                        "
                        color="primary"
                        fill="clear"
                        class="upload-btn"
                    >
                        <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                        {{ complete?.purchasedMalpractice ? 'Upload New Document' : 'Upload Document' }}
                    </ion-button>
                </div>
            </ion-col>
            <ion-col
                *ngIf="status?.application?.type === 'Hands-On' && !customReqMalpracticeCheck"
                size="4"
                size-xs="6"
                size-sm="6"
                size-md="6"
                size-lg="4"
                size-xl="4"
                class="requirement-col"
            >
                <div class="requirement-content">
                    <div class="ion-text-center" *ngIf="complete?.purchasedMalpractice">
                        <ion-button
                            (click)="viewMalpracticeDocument()"
                            class="upload-btn upload-btn-color"
                            fill="clear"
                            [disabled]="status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled'"
                        >
                            View document
                        </ion-button>

                        <div class="ion-text-center chip-container">
                            <app-document-status-chip [checklist]="checklistStatus" [type]="'malpractice'"></app-document-status-chip>
                        </div>
                    </div>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>
        </ion-row>

        <ion-row class="new-design" *ngIf="!complete?.isOnlineTelehealth || requirementsList?.length > 0">
            <!-- HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF-->
            <!-- HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF-->
            <!-- HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF-->
            <!-- HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF HOUSING PROOF-->

            <ion-col size="12" class="row-main-title">
                <div class="title-section">
                    <div class="title-container">
                        <ion-label class="title">
                            {{ (toolService.content | async)?.application?.components?.generalDocuments?.additional?.titleNew }}
                        </ion-label>
                    </div>
                </div>
            </ion-col>

            <ion-col *ngIf="!complete?.isOnlineTelehealth" size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4" class="requirement-col">
                <div class="requirement-content">
                    <div>
                        <ion-label class="ion-text-wrap">
                            <fa-icon [icon]="icons.file"></fa-icon>
                            <span class="bold-text padding-left">
                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.additional?.housingbutton }}
                            </span>
                        </ion-label>
                        <br />
                        <div class="ion-text-center health-link-container">
                            <ion-text>
                                <ion-button type="button" fill="clear" class="link-anchor link-padding form-text" (click)="openHousingSuggestionsModal()">
                                    {{ (toolService.content | async)?.application?.components?.generalDocuments?.additional?.needhousing }}
                                </ion-button>
                            </ion-text>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col *ngIf="!complete?.isOnlineTelehealth" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
                <div class="requirement-content">
                    <div class="ion-text-center">
                        <div>
                            <ion-button (click)="openHousingModal()" fill="clear" color="primary" class="upload-btn">
                                <fa-icon [icon]="icons.faHouse" slot="start"></fa-icon>

                                {{ (toolService.content | async)?.application?.components?.generalDocuments?.additional?.housingbutton }}
                            </ion-button>
                        </div>
                    </div>
                </div>
            </ion-col>
            <ion-col *ngIf="!complete?.isOnlineTelehealth" size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
                <div class="requirement-content">
                    <ion-chip *ngIf="complete?.hashousing" class="accepted-chip-housing" mode="ios" outline="true">
                        <fa-icon [icon]="icons.completed"></fa-icon> <ion-label>Submitted</ion-label>
                    </ion-chip>
                </div>
            </ion-col>
            <div class="requirement-divider"></div>

            <!-- ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS -->
            <!-- ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS -->
            <!-- ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS -->
            <!-- ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS ADDITIONAL DOCUMENTS -->

            <ng-container *ngFor="let document of requirementsList; let i = index">
                <ion-col size="4" size-xs="12" size-sm="12" size-md="12" size-lg="4" size-xl="4" class="requirement-col">
                    <div class="requirement-content">
                        <div>
                            <ion-label class="ion-text-wrap">
                                <fa-icon [icon]="icons.file"></fa-icon>
                                <span class="bold-text padding-left">
                                    {{ document?.jsondata?.name }}
                                </span>
                            </ion-label>

                            <ion-text color="text" [innerHTML]="document?.jsondata?.description | nbspToSpace | safe : 'html'"> </ion-text>
                            <div class="info-divs">
                                <a
                                    *ngIf="!complete?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'"
                                    (click)="purchaseMalpractice()"
                                    [disabled]="status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled'"
                                    class="anchor-btn-info"
                                >
                                    <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                    <span>Purchase Malpractice Insurance</span>
                                </a>
                                <span *ngIf="!complete?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'" class="card-text learn-more">
                                    <a class="learn-more" (click)="openTooltip($event, 'MalpractiseInsurance', 'infocircle')">
                                        <fa-icon [icon]="icons.faInfoCircle" slot="start"></fa-icon>
                                        <span>Learn more</span>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </ion-col>
                <ion-col size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
                    <div class="requirement-content">
                        <!-- NON MALPRACTICE -->
                        <div *ngIf="document?.jsondata?.type !== 'malpractice'">
                            <!-- HAS DOCUMENT TO DOWNLOAD FOR THE TRAINEE AND UPLOAD BACK -->
                            <div *ngIf="document?.Document?.key && document?.jsondata?.usersubmission">
                                <ion-button
                                    (click)="
                                        downloadThenUploadModal(
                                            'application',
                                            document?.Document.key,
                                            document?.Document.filename,
                                            i,
                                            document?.jsondata?.name,
                                            document?.jsondata?.usersubmission,
                                            document?.applicationRequirementId,
                                            document?.level,
                                            document?.levelid
                                        )
                                    "
                                    class="upload-btn"
                                    fill="clear"
                                    color="primary"
                                    [disabled]=""
                                    [disabled]="
                                        checklistStatus
                                            | checklist
                                                : 'postreservation'
                                                : document?.applicationRequirementId ||
                                                      (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                                    "
                                >
                                    <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                    {{ document?.submitted ? 'Download and Resubmit' : 'Download and Submit' }}
                                </ion-button>
                            </div>
                            <!-- HAS DOCUMENT TO DOWNLOAD BUT NO SUBMISSION NEEDED -->
                            <div *ngIf="document?.Document?.key && !document?.jsondata?.usersubmission">
                                <ion-button
                                    (click)="
                                        downloadThenUploadModal(
                                            'application',
                                            document?.Document.key,
                                            document?.Document.filename,
                                            i,
                                            document?.jsondata?.name,
                                            document?.jsondata?.usersubmission,
                                            document?.applicationRequirementId,
                                            document?.level,
                                            document?.levelid
                                        )
                                    "
                                    class="upload-btn"
                                    fill="clear"
                                    color="primary"
                                    [disabled]=""
                                    [disabled]="
                                        checklistStatus
                                            | checklist
                                                : 'postreservation'
                                                : document?.applicationRequirementId ||
                                                      (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                                    "
                                >
                                    <fa-icon [icon]="icons.download" slot="start"></fa-icon>
                                    {{ document?.submitted ? 'Download Again' : 'Download' }}
                                </ion-button>
                            </div>
                            <!-- DOES NOT HAVE DOCUMENT TO DOWNLOAD FOR TRAINEE -->
                            <div *ngIf="!document?.Document?.key && document?.jsondata?.usersubmission">
                                <ion-button
                                    (click)="
                                        additionalFileUpload(
                                            'application',
                                            document?.applicationRequirementId,
                                            document?.jsondata?.name,
                                            i,
                                            document?.level,
                                            document?.levelid,
                                            document?.jsondata?.usersubmission
                                        )
                                    "
                                    class="upload-btn"
                                    fill="clear"
                                    color="primary"
                                    [disabled]="
                                        checklistStatus
                                            | checklist
                                                : 'postreservation'
                                                : document?.applicationRequirementId ||
                                                      (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                                    "
                                >
                                    <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                    {{ document?.submitted ? 'Upload New Document' : 'Upload Document' }}
                                </ion-button>
                            </div>
                            <!-- DOES NOT HAVE DOCUMENT TO DOWNLOAD AND NO USER SUBMISSION -->
                            <div *ngIf="!document?.Document?.key && !document?.jsondata?.usersubmission">
                                <ion-button
                                    (click)="
                                        additionalFileUpload(
                                            'application',
                                            document?.applicationRequirementId,
                                            document?.jsondata?.name,
                                            i,
                                            document?.level,
                                            document?.levelid
                                        )
                                    "
                                    class="upload-btn"
                                    fill="clear"
                                    color="primary"
                                    [disabled]="
                                        checklistStatus
                                            | checklist
                                                : 'postreservation'
                                                : document?.applicationRequirementId ||
                                                      (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                                    "
                                >
                                    <fa-icon [icon]="icons.acknowledged" slot="start"></fa-icon>
                                    Acknowledge
                                </ion-button>
                            </div>
                        </div>
                        <div *ngIf="document?.jsondata?.type === 'malpractice'">
                            <div class="ion-text-center" *ngIf="!complete?.purchasedMalpractice">
                                <ion-button
                                    (click)="upload('malpractice', 'none')"
                                    class="upload-btn"
                                    fill="clear"
                                    color="primary"
                                    [disabled]="
                                        checklistStatus
                                            | checklist
                                                : 'postreservation'
                                                : document?.applicationRequirementId ||
                                                      (status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled')
                                    "
                                >
                                    <fa-icon [icon]="icons.incompleted" slot="start"></fa-icon>
                                    {{ complete?.purchasedMalpractice ? 'Upload New Document' : 'Upload Document' }}
                                </ion-button>
                            </div>
                        </div>
                    </div>
                </ion-col>
                <ion-col size="4" size-xs="6" size-sm="6" size-md="6" size-lg="4" size-xl="4" class="requirement-col">
                    <div class="requirement-content">
                        <div class="ion-text-center" *ngIf="complete?.purchasedMalpractice && document?.jsondata?.type === 'malpractice'">
                            <ion-button
                                (click)="viewMalpracticeDocument()"
                                class="upload-btn upload-btn-color"
                                expand="block"
                                fill="clear"
                                shape="round"
                                [disabled]="status?.application?.states !== 'Reserved' && status?.application?.states !== 'Enrolled'"
                            >
                                <!-- <fa-icon [icon]="icons.file" slot="start"></fa-icon> -->
                                <!-- <ng-container [ngTemplateOutlet]="selectIconOnCondition"></ng-container> -->
                                <ion-text class="ion-text-wrap"> View document </ion-text>
                            </ion-button>

                            <div class="ion-text-center chip-container">
                                <app-document-status-chip
                                    [checklist]="checklistStatus"
                                    [requirementId]="document?.applicationRequirementId"
                                ></app-document-status-chip>
                            </div>
                            <!-- <ion-icon class="doc-comp" size="medium" color="success" name="checkmark-circle-outline"></ion-icon> -->
                            <!-- <ion-icon class="doc-comp" size="medium" color="danger" name="alert"></ion-icon> -->
                        </div>
                        <div *ngIf="document?.jsondata?.type !== 'malpractice' && document?.submitted">
                            <div class="ion-padding-top">
                                <ion-button
                                    *ngIf="document?.urlSubmitted"
                                    (click)="viewAdditionalDocument(document, document?.urlSubmitted)"
                                    class="upload-btn upload-btn-color"
                                    expand="block"
                                    fill="clear"
                                    shape="round"
                                >
                                    View document
                                </ion-button>

                                <div class="ion-text-center chip-container">
                                    <app-document-status-chip
                                        [checklist]="checklistStatus"
                                        [requirementId]="document?.applicationRequirementId"
                                    ></app-document-status-chip>
                                </div>
                            </div>
                        </div>
                    </div>
                </ion-col>
                <div class="requirement-divider"></div>
            </ng-container>
        </ion-row>
    </div>
    <a class="download-zip-link" #downloadZipLink></a>
</div>
<ng-template #selectIconOnCondition>
    <fa-icon [icon]="icons.rejectedOrAccepted" slot="start" class="rejectedOrAccepted icons"></fa-icon>
    <!-- <fa-icon  [icon]="icons.rejectedOrAccepted" slot="start"></fa-icon> -->
    <fa-icon [icon]="icons.incompleted" slot="start" class="incompleted icons"></fa-icon>
    <fa-icon [icon]="icons.completed" slot="start" class="completed icons"></fa-icon>
    <fa-icon [icon]="icons.blocked" slot="start" class="blocked icons"></fa-icon>
    <!-- <fa-icon  [icon]="icons.incompleted" slot="start" class="noclass"></fa-icon> -->
</ng-template>
